import get from 'lodash/get';
import includes from 'lodash/includes'
import find from 'lodash/find'
import Account from '@/models/users/accounts/'
import Subscription from '@/models/tags/Subscription'
import Tag from '@/models/tags'
import Brand from '@/models/catalog/brand/'
import Perfumer from '@/models/catalog/Perfumer/'

export default {
    data() {
        return {
            tagSubscriptionId: null,
            catalogSubscriptionId: null,
            emailSubscriptionId: null,
            subscriptionModel: null,
            updateSubscriptionsTimeout: false
        }
    },
    created() {

        this.subscriptionModel = this.getSubscribeModel();

        const subscribeCallback = value => {
            this.onSubscribe(value)
        }

        const onsubscribeCallback = config => {
            this.doSubscription(config)
        }

        if (process.client) {
            this.$bus.$on('subscribe', subscribeCallback)
            this.$bus.$on('on-entity-subscribe', onsubscribeCallback)

            /* Снимаем обработчики при разрушении компонента */
            this.$once('hook:beforeDestroy', () => {
                this.$bus.$off('subscribe', subscribeCallback)
                this.$bus.$off('on-entity-subscribe', onsubscribeCallback)
            })
        }
    },
    computed: {
        userSubscribed() {
            return !!(this.tagSubscriptionId || this.catalogSubscriptionId || this.emailSubscriptionId)
        }
    },
    methods: {
        getSubscriptionsRequests() {
            const account = new Account

            return [
                account.subscriptions().params({type: 'catalog'}).get(),
                account.subscriptions().params({type: 'tags'}).get(),
                account.subscriptions().params({type: 'catalog', is_email_subscription: 'y'}).get(),
            ]
        },
        parseSubscriptions(results) {
            const catalog = get(results, '[0][0].items', [])
            const tags = get(results, '[1][0].items', [])
            const emails = get(results, '[2][0].items', [])

            this.catalogSubscriptionId = get(find(catalog, item => {
                return get(item, 'entity.code') === this.entityCode
            }), 'id');

            if (this.entityTag) {

                this.tagSubscriptionId = get(find(tags, tag => {
                    return tag.entity.code === this.entityTag.code
                }), 'id')

                this.emailSubscriptionId = get(find(emails, e => {
                    return e.entity.code === this.entityCode
                }), 'id')
            }
        },
        showSubscriptionPopup(config) {
            const { type, entity, entityTag, withEmail } = config;

            this.showPopup('subscribe', {
                type,
                entity,
                entityTag,
                withEmail,
                subscriptions: {
                    catalog: !!this.catalogSubscriptionId,
                    tag: !!this.tagSubscriptionId,
                    email: !!this.emailSubscriptionId,
                },
                eventName: 'on-entity-subscribe'
            })
        },
        showAlert(type, key) {
            this.$alert[type](this.$t(key))
        },
        getSubscribeModel(type) {
            const account = new Account
            const subscription = new Subscription

            let model = {}

            if (type === 'tag') {
                model = new Tag({ tag_code: this.entityTag.code })
            }else if (this.perfumer && type === 'email') {
                model = new Perfumer({
                    perfumer_code: this.entityCode,
                    is_email_subscription: 'y'
                });
            } else if (type === 'email') {
                model = new Brand({
                    brand_code: this.entityCode,
                    is_email_subscription: 'y'
                })
            } else {
                if (!this.entityModel) return

                model = this.entityModel

                if (this.subscriptionModel) {
                    return this.subscriptionModel
                }
            }

            return model.for(account, subscription)
        },
        updateSubscriptions() {
            return Promise.all(this.getSubscriptionsRequests()).then(results => {
                this.parseSubscriptions(results)
            })
        },
        subscribeEntity(type, code) {
            const subscribeModel = this.getSubscribeModel(type)
            return subscribeModel.save()
        },
        unsubscribeEntity(id) {
            const account = new Account
            const unsubscribeModel = new Subscription({ id }).for(account)

            return unsubscribeModel.delete()
        },
        triggerSubscribe(type, status, entityId) {
            if (!status && !entityId) return;

            if (this.updateSubscriptionsTimeout) {
                clearTimeout(this.updateSubscriptionsTimeout);
            }
            this.updateSubscriptionsTimeout = setTimeout(this.updateSubscriptions, 500);

            if (!status && entityId) {
                this.unsubscribeEntity(entityId)
                return 'unsubscribed'
            }

            if (status && !entityId) {
                this.subscribeEntity(type)
            }

            return 'subscribed';
        },
        subscribeCatalog(status) {
            return this.triggerSubscribe('catalog', status, this.catalogSubscriptionId)
        },
        subscribeTag(status) {
            return this.triggerSubscribe('tag', status, this.tagSubscriptionId)
        },
        subscribeEmail(status) {
            return this.triggerSubscribe('email', status, this.emailSubscriptionId)
        },
        doSubscription(config) {
            let alertCode = ''

            const results = []

            if ('catalog' in config)
                results.push(this.subscribeCatalog(config.catalog))

            if (this.entityTag){

                if ('tag' in config)
                    results.push(this.subscribeTag(config.tag))

                if ('email' in config)
                    results.push(this.subscribeEmail(config.email));
            }

            const status = includes(results, 'subscribed')

            if (config.isSave){
                alertCode = 'alerts.changes_saved'
            } else if (status) {
                alertCode = this.subscriptionModel ?
                    'alerts.subscribe_success' :
                    'alerts.subscribe_tag_success'
            } else {
                alertCode = this.subscriptionModel ?
                    'alerts.unsubscribe_success' :
                    'alerts.unsubscribe_tag_success'
            }

            this.showAlert('success', alertCode);

            if(config.email && !get(this.$auth, 'user.email')){
                this.showPopup('tooltip', {
                    title: this.$t('subscribe_email_title'),
                    content: this.$t('subscribe_email_text'),
                    buttonText: this.$t('subscribe_email_button'),
                    buttonEvent: 'goToUserSettings'
                },{
                    width: '340px'
                })
            }
        },
        onSubscribe(config) {
            this.showSubscriptionPopup(config)
        },
    }
}
